import React, { Component } from "react";
import * as s from "./TopicInformation.module.scss";
import { StaticQuery, graphql } from "gatsby";
import { createMarkup } from "src/libs/utils";
import { P } from "src/views/shared/components";
import { Icons } from "src/libs/assets";
import { ISettings, ISingleDocumentTopic } from "src/models";
import { BackgroundImage } from "../BackgroundImage";
import { tx } from "src/libs/i18n";

interface Props {
  topic: ISingleDocumentTopic;
  settings: ISettings;
}

interface State {
  fullHeight: boolean;
}

class TopicInformationComponent extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { fullHeight: false };
  }

  toggleHeight = () => {
    const { fullHeight } = this.state;
    this.setState({ fullHeight: !fullHeight });
  };

  render() {
    const { fullHeight } = this.state;
    const { topic } = this.props;
    const { name, description, topicImageFields } = topic;
    const { topicImage, topicImageCaption, topicImageReference } = topicImageFields || {};

    let topicContentContainerClasses = [s.topicContentContainer];
    let showMoreMaskClasses = [s.showMoreMask];
    let showMoreText = tx("misc.showMore");

    if (fullHeight) {
      topicContentContainerClasses.push(s.fullHeight);
      showMoreMaskClasses.push(s.fullHeight);
      showMoreText = tx("misc.showLess");
    }

    return (
      <div className={s.topicInformation}>
        {/* <div className={s.topicCTAContainer}>
          <div className={s.subscribeWrapper}></div>
          <P small className={s.subscribeText}>
            Subscribe to this topic
          </P>

          <img
            src={Icons.subscribe_small}
            alt="subscribe-icon"
            className={s.subscribeIcon}
          />
          <img
            src={Icons.externalLink_small}
            alt="subscribe-icon"
            className={s.copyLinkIcon}
          />
        </div> */}
        <div className={topicContentContainerClasses.join(" ")}>
          <P small className={s.containerLabel}>
            {tx("topicInformation.aboutTheTopic")}
          </P>
          <h1 className={s.topicTitle}>{name}</h1>
          {topicImage ? (
            <div className={s.topicImageContainer}>
              <BackgroundImage
                image={topicImage}
                alt={"topicImage"}
                className={s.topicImage}
              />

              {topicImageCaption && (
                <P small className={s.topicImageCaption}>
                  {topicImageCaption}
                </P>
              )}
              {topicImageReference && (
                <P small className={s.topicImageDescription}>
                  {topicImageReference}
                </P>
              )}
            </div>
          ) : null}
          {description && (
            <P medium className={s.topicDescription}>
              <div dangerouslySetInnerHTML={createMarkup(description)} />
            </P>
          )}
        </div>

        {description && (
          <div className={s.toggleShowMoreRow}>
            <div className={showMoreMaskClasses.join(" ")} />
            <div className={s.toggleShowMoreTextContainer}>
              <P className={s.toggleShowMoreText} onClick={this.toggleHeight}>
                {showMoreText}
              </P>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export const TopicInformation = ({ topic, ...rest }) => (
  <StaticQuery
    query={query}
    render={data => {
      return (
        <TopicInformationComponent topic={topic} settings={data.siteSettings} {...rest} />
      );
    }}
  />
);

// Fetch all first level topics
const query = graphql`
  query {
    ...siteSettingsFragment
  }
`;
